<template>
  <div>
    <div class="p-grid">
      <div class="p-col">
        <Button class="p-button-raised p-button-rounded" style="float:right" @click.prevent="openBasic"
                icon="pi pi-plus"/>
      </div>
    </div>
    <Dialog header="Unit Conversion" :modal="true" :contentStyle="{'overflow': 'visible'}"
            :style="{width: '50vw'}" :visible.sync="displayBasic" :closable=false>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="name">Name<span style="color:red">*</span></label>
          <InputText v-model.trim="name" id="name"/>
        </div>
        <div class="p-field p-col-12 p-md-6"></div>
        <div class="p-field p-col-12 p-md-4">
          <label for="unitFrom">Unit From</label>
          <Dropdown v-model="unitFrom" :options="measurementUnitList" id="unitFrom"
                    optionLabel="shortName" :filter="true" placeholder="Select Unit" :showClear="true"/>
        </div>
        <MeasurementUnit style="margin-top:1.3em;" v-tooltip.top="'Add Unit'"/>

        <div class="p-field p-col-12 p-md-4">
          <label for="unitFrom">Unit To</label>
          <Dropdown v-model="unitTo" :options="measurementUnitList" id="unitTo"
                    optionLabel="shortName" :filter="true" placeholder="Select Unit" :showClear="true"/>
        </div>
        <MeasurementUnit style="margin-top:1.3em;" v-tooltip.top="'Add Unit'"/>
        <div class="p-field p-col-12 p-md-4">
          <label for="unitValue1">Unit Value</label>
          <InputText v-model.trim="unitFromValue" id="unitValue1"/>
        </div>
        <label ></label>
        <div class="p-field p-col-12 p-md-3">
          <label for="unitValue2">Unit Value</label>
          <InputText v-model.trim="unitToValue" id="unitValue2"/>
        </div>
      </div>
      <template #footer>
        <Button class="p-button-raised p-button-rounded" :label="editing?'Update':'Add'"
                @click.prevent="addUnitConversion"/>
        <Button class="p-button-raised p-button-info" v-if="!editing"
                @click.prevent="addAndNewUnitConversion"
                label="Add & New"/>
        <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import MeasurementUnit from './measurementUnitDialog.vue'
import Dropdown from 'primevue/dropdown'

export default {
  name: 'UnitConversionDialog',
  data() {
    return {
      name: '',
      unitFrom: '',
      unitTo: '',
      unitFromValue: 0,
      unitToValue: 0,
      measurementUnit: {},
      editing: false,
      id: '',
      loading: false,
      displayBasic: false
    }
  },
  mounted() {
    this.unitList()
  },
  computed: {
    measurementUnitList() {
      return this.$store.state.itemgroup.measurementUnitLists
    }
  },
  methods: {
    async unitList() {
      await this.$store.dispatch('loadMeasurementList')
    },
    async addUnitConversion() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty', life: 3000})
        return
      }
      if (this.unitTo === '' || this.unitFrom === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Unit', life: 3000})
        return
      }
      if (this.unitFromValue <= 0 || this.unitToValue <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter Unit value', life: 3000})
        return
      }
      // eslint-disable-next-line no-unused-vars
      let response = ''
      let unitConversion = {
        id: this.id,
        name: this.name,
        unitFrom: this.unitFrom,
        unitTo: this.unitTo,
        unitFromValue: this.unitFromValue,
        unitToValue: this.unitToValue
      }
      if (!this.editing) {
        this.loading = !this.loading
        response = await this.$store.dispatch('createUnitConversion', unitConversion)
        this.loading = false
      } else {
        this.loading = !this.loading
        response = await this.$store.dispatch('updateUnitConversion', unitConversion)
        this.loading = false
      }
      this.responseMessage(response)
      this.closeBasic()
    },
    async addAndNewUnitConversion() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty', life: 3000})
        return
      }
      if (this.unitTo === '' || this.unitFrom === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Unit', life: 3000})
        return
      }
      if (this.unitFromValue <= 0 || this.unitToValue <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter Unit value', life: 3000})
        return
      }
      // eslint-disable-next-line no-unused-vars
      let response = ''
      let unitConversion = {
        name: this.name,
        unitFrom: this.unitFrom,
        unitTo: this.unitTo,
        unitFromValue: this.unitFromValue,
        unitToValue: this.unitToValue
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('createUnitConversion', unitConversion)
      this.loading = false
      this.responseMessage(response)
    },
    editUnitConversion(data) {
      this.openBasic()
      this.editing = true
      this.id = data.id
      this.name = data.name
      this.unitTo = data.unitTo
      this.unitFrom = data.unitFrom
      this.unitFromValue = data.unitFromValue
      this.unitToValue = data.unitToValue
    },
    responseMessage(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 3000})
      }
    },
    openBasic() {
      this.displayBasic = true
    },
    cancel() {
      this.closeBasic()
      // this.reset()
    },
    closeBasic() {
      this.displayBasic = false
    },
    reset() {
      this.name = ''
      this.unitFrom = ''
      this.unitTo = ''
      this.unitToValue = 0
      this.unitFromValue = 0
      this.editing = false
    }
  },
  components: {
    Button,
    Dialog,
    InputText,
    MeasurementUnit,
    Dropdown
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// UnitConversionDialog.vue?3d20a666